/** Compare semver strings. Returns -1 if a<b, 0 if equal, 1 if a>b. */
export function compareAppVersion(a: string, b: string): number {
  const pa = a.split(".").map((n) => parseInt(n, 10) || 0);
  const pb = b.split(".").map((n) => parseInt(n, 10) || 0);
  const len = Math.max(pa.length, pb.length);
  for (let i = 0; i < len; i++) {
    const da = pa[i] ?? 0;
    const db = pb[i] ?? 0;
    if (da < db) return -1;
    if (da > db) return 1;
  }
  return 0;
}

export function isAppVersionBelow(current: string, minimum: string): boolean {
  return compareAppVersion(current, minimum) < 0;
}
